import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { LoadingPanelModule } from '../../../loading-panel/loading-panel.module';
import { RadioGroupModule } from '../../../radio-group/radio-group.module';
import { RangeSliderModule } from '../../../range-slider/range-slider.module';
import { LayerListEffectComponent } from './layer-list-effect.component';

@NgModule({
  imports: [
    CommonModule,
    RadioGroupModule,
    RangeSliderModule,
    LoadingPanelModule,
    BlockModalDragModule,
  ],
  declarations: [LayerListEffectComponent],
  exports: [LayerListEffectComponent],
})
export class LayerListEffectModule {}
